// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__m3Zpq","title":"style__title__Yrq81","description":"style__description__aMcCZ","component":"style__component__g3gki"};